import { Messages } from '../../../../codegen/Localize';
import { IScheduleInfo } from '../../../../ts/models/IScheduleInfo';
import { scheduleDisable } from '../../../actions/spaces/ScheduleMenuActions';
import { AppState } from '../../../state/AppState';
import { EntityActionNames, IEntityAction } from './IEntityAction';
import { anyEnabledSchedule, userCanEditSchedule } from './IEntityActionHelpers';

export const ScheduleDisableAction: IEntityAction<IScheduleInfo, {}> = {
  name: EntityActionNames.DisableSchedules,
  translateName: Messages.disable_action,
  isVisible: (targetItems: IScheduleInfo[], state: AppState) => {
    return targetItems.length > 0 && userCanEditSchedule(state, targetItems);
  },
  isClickable: (_availableActions: {}, targetItems: IScheduleInfo[]) => {
    return anyEnabledSchedule(targetItems);
  },
  createReduxAction: (targetItems: IScheduleInfo[]) => scheduleDisable(targetItems)
};
